import StarterKit from '@tiptap/starter-kit';
import TextAlign from '@tiptap/extension-text-align';
import { TextStyle, FontSize } from '@tiptap/extension-text-style';
import { TableKit } from '@tiptap/extension-table';
import { Placeholder } from '@tiptap/extensions';

// Extensions of the "basic Word" editor. Any change here changes the JSON schema saved in
// contentJson and the HTML sent to the backend PDF renderer, so keep both sides in sync.
export const documentEditorExtensions = [
  StarterKit.configure({
    heading: { levels: [1, 2, 3] },
    code: false,
    codeBlock: false,
    link: { openOnClick: false, autolink: true },
  }),
  TextAlign.configure({ types: ['heading', 'paragraph'] }),
  TextStyle,
  FontSize,
  TableKit.configure({ table: { resizable: false } }),
  Placeholder.configure({ placeholder: 'Digite o conteúdo do documento...' }),
];

export const FONT_SIZES = ['10pt', '11pt', '12pt', '14pt', '16pt', '18pt', '24pt'];

export const DEFAULT_FONT_SIZE = '12pt';

// Page look shared by the editor so what the user types matches the printed/signed PDF.
export const documentPageSx = {
  '& .ProseMirror': {
    outline: 'none',
    minHeight: '220mm',
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontSize: DEFAULT_FONT_SIZE,
    lineHeight: 1.5,
    color: '#000',
    wordBreak: 'break-word',
  },
  '& .ProseMirror p': { margin: '0 0 0.5em' },
  '& .ProseMirror h1': { fontSize: '20pt', margin: '0.6em 0 0.4em' },
  '& .ProseMirror h2': { fontSize: '16pt', margin: '0.6em 0 0.4em' },
  '& .ProseMirror h3': { fontSize: '13pt', margin: '0.6em 0 0.4em' },
  '& .ProseMirror ul, & .ProseMirror ol': { paddingLeft: '1.5em', margin: '0 0 0.5em' },
  '& .ProseMirror hr': { border: 'none', borderTop: '1px solid #000', margin: '1em 0' },
  '& .ProseMirror a': { color: '#1565c0' },
  '& .ProseMirror table': {
    borderCollapse: 'collapse',
    width: '100%',
    margin: '0.5em 0',
    tableLayout: 'fixed',
  },
  '& .ProseMirror th, & .ProseMirror td': {
    border: '1px solid #000',
    padding: '4px 6px',
    verticalAlign: 'top',
    position: 'relative',
  },
  '& .ProseMirror th': { backgroundColor: '#f2f2f2', fontWeight: 'bold' },
  '& .ProseMirror th p, & .ProseMirror td p': { margin: 0 },
  '& .ProseMirror .selectedCell::after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    backgroundColor: 'rgba(25, 118, 210, 0.15)',
    pointerEvents: 'none',
  },
  '& .ProseMirror p.is-editor-empty:first-of-type::before': {
    content: 'attr(data-placeholder)',
    color: '#9e9e9e',
    float: 'left',
    height: 0,
    pointerEvents: 'none',
  },
};
